import { render, staticRenderFns } from "./sketchRuler.vue?vue&type=template&id=24049e54&"
import script from "./sketchRuler.vue?vue&type=script&lang=js&"
export * from "./sketchRuler.vue?vue&type=script&lang=js&"
import style0 from "./sketchRuler.vue?vue&type=style&index=0&id=24049e54&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports